import React from "react";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { propTypes } from "react-bootstrap/esm/Image";
import Cookies from "universal-cookie";
import GetProxy from "../../common/GetProxy";
import { handleResponseCode } from "../../../app/utilities/helpers";
const proxy = GetProxy();
const cookies = new Cookies();

export const LoginTrendApi = createAsyncThunk(
  "post/LoginTrendApi",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(`${proxy}/api/v1/g&c/activeUserCount`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);

export const ActiveUsersLast = createAsyncThunk(
  "post/ActiveUsersLast",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/getCountofActiveUsers`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);

export const CurrentDayLoggedUsersPerToolsApi = createAsyncThunk(
  "post/CurrentDayLoggedUsersPerTools",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/licenseManagementForTools/currentToolUtilization`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const BitbucketUserDetailsListAPI = createAsyncThunk(
  "post/BitbucketUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/bitbucketLoggedUserDetails/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const BitbucketUserDetailsCountAPI = createAsyncThunk(
  "post/BitbucketUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/getKeywordUsageCountForBitbucketLoggedUserDetails`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
//Jenkins User Details
export const JenkinsUserDetailsListAPI = createAsyncThunk(
  "post/JenkinsUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/jenkinsLoggedUserDetails/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const JenkinsUserDetailsCountAPI = createAsyncThunk(
  "post/JenkinsUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/getKeywordUsageCountForJenkinsLoggedUserDetails`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const JiraUserDetailsListAPI = createAsyncThunk(
  "post/JiraUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, toolName, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/licenseManagementForTools/getTotalUsersList/${toolName}/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const JiraUserDetailsCountAPI = createAsyncThunk(
  "post/JiraUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload , toolName} = props;
      const response = await fetch(
        `${proxy}/api/v1/licenseManagementForTools/getTotalUsersListForCount/${toolName}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const ConfluenceUserDetailsListAPI = createAsyncThunk(
  "post/ConfluenceUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/confluenceLoggedUserDetails/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const ConfluenceUserDetailsCountAPI = createAsyncThunk(
  "post/ConfluenceUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/getKeywordUsageForConfluenceLoggedUserDetails`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);

// Active users
export const BitbucketActiveUserDetailsListAPI = createAsyncThunk(
  "post/BitbucketActiveUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/currentDayBitbucketLoggedUserDetailsWithSearchAndPagination/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const BitbucketActiveUserDetailsCountAPI = createAsyncThunk(
  "post/BitbucketActiveUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/getKeywordUsageForCurrentDayBitbucketLoggedUserDetails`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const JenkinsActiveUserDetailsListAPI = createAsyncThunk(
  "post/JenkinsActiveUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/currentDayJenkinsLoggedUserDetailsWithPagination/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const JenkinsActiveUserDetailsCountAPI = createAsyncThunk(
  "post/JenkinsActiveUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/getKeywordUsageCountCurrentDayJenkins`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const JiraActiveUserDetailsListAPI = createAsyncThunk(
  "post/JiraActiveUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, toolName, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/licenseManagementForTools/getActiveUsersList/${toolName}/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const JiraActiveUserDetailsCountAPI = createAsyncThunk(
  "post/JiraActiveUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload , toolName} = props;
      const response = await fetch(
        `${proxy}/api/v1/licenseManagementForTools/getActiveUsersListForCount/${toolName}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);

export const JiraInActiveUserDetailsListAPI = createAsyncThunk(
  "post/JiraInActiveUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, toolName, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/licenseManagementForTools/getInActiveUsersList/${toolName}/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const JiraInActiveUserDetailsCountAPI = createAsyncThunk(
  "post/JiraInActiveUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload , toolName} = props;
      const response = await fetch(
        `${proxy}/api/v1/licenseManagementForTools/getInActiveUsersListForCount/${toolName}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const ConfluenceActiveUserDetailsListAPI = createAsyncThunk(
  "post/ConfluenceActiveUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/currentDayConfluenceLoggedUserDetailsWithSearchAndPagination/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const ConfluenceActiveUserDetailsCountAPI = createAsyncThunk(
  "post/ConfluenceActiveUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/getKeywordUsageForCurrentDayConfluenceLoggedUserDetails`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const ConfluenceInActiveUserDetailsListAPI = createAsyncThunk(
  "post/ConfluenceInActiveUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/confluenceInactiveUsersList/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const ConfluenceInActiveUserDetailsCountAPI = createAsyncThunk(
  "post/ConfluenceInActiveUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/confluenceInactiveUsersKeywordUsage`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
// InActive users
export const BitbucketInActiveUserDetailsListAPI = createAsyncThunk(
  "post/BitbucketInActiveUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/bitBucketInactiveUsersList/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const BitbucketInActiveUserDetailsCountAPI = createAsyncThunk(
  "post/BitbucketInActiveUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/bitBucketInactiveUsersKeywordUsage`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const JenkinsInActiveUserDetailsListAPI = createAsyncThunk(
  "post/JenkinsInActiveUserDetailsListAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {pageNumber, itemsPerPage, payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/jenkinsInactiveUsersList/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const JenkinsInActiveUserDetailsCountAPI = createAsyncThunk(
  "post/JenkinsInActiveUserDetailsCountAPI",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/g&c/getKeywordUsageCountJenkinsInactive`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);
export const Activeuserdonut = createAsyncThunk(
  "post/Activeuserdonut",
  async (props) => {
    console.log(props)
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const {payload} = props;
      const response = await fetch(
        `${proxy}/api/v1/licenseManagementForTools/getActiveUserTrendChartCount`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          body: JSON.stringify(props),
        }
      );
      // handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      throw error;
    }
  }
);

export const getCurrentLicenseUtilization= createAsyncThunk("get/getCurrentLicenseUtilization", async () => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const response = await fetch(`${proxy}/api/v1/softwareInventory/getCurrentLicenseUtilization`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "CMTS-API-TOKEN": apiToken,
        USERNAME: username,
      },
    });
    handleResponseCode(response);
    const data = await response.json();
    return response.ok ? data : Promise.reject(data)
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}
);
export const insightsbyDisTypeAPI = createAsyncThunk(
  "post/insightsbyDisTypeAPI",
  async () => {
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const res = await fetch(
          `${proxy}/api/v1/softwareInventory/getCountsByTypeAndEntry`,
          {
              method: "GET",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  "CMTS-API-TOKEN": Apitoken,
                  USERNAME: User,
              },
          }
      ).then((resp) => resp.json());
      handleResponseCode(res)
      return res;
  }
);

export const getAnsibleAPI= createAsyncThunk(
  "get/getAnsibleAPI", async () => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const response = await fetch(`${proxy}/api/v1/ansible/getDetails`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "CMTS-API-TOKEN": apiToken,
        USERNAME: username,
      },
    });
    handleResponseCode(response);
    const data = await response.json();
    return response.ok ? data : Promise.reject(data)
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}
);

const initialState = {
  LoginTrendData: [],
  ActiveUsersLastData: [],
  LoginTrendloading: false,
  ActiveUsersLastLoading: false,
  BitbucketUserDetailsList:[],
  BitbucketUserDetailsListLoading: false,
  JenkinsUserDetailsList:[],
  JenkinsUserDetailsListLoading: false,
  CurrentDayToolsLoggedUsersLoading: false,
  CurrentDayToolsLoggedUsers:[],
  BitbucketUserDetailsCount:[],
  BitbucketUserDetailsCountLoading: false,
  JenkinsUserDetailsCount:[],
  JenkinsUserDetailsCountLoading: false,
  JiraUserDetailsList:[],
  JiraUserDetailsListLoading: false,
  JiraUserDetailsCount:[],
  JiraUserDetailsCountLoading: false,
  ConfluenceUserDetailsList:[],
  ConfluenceUserDetailsListLoading: false,
  ConfluenceUserDetailsCount:[],
  ConfluenceUserDetailsCountLoading: false,
  // Active users 
  BitbucketActiveUserDetailsList:[],
  BitbucketActiveUserDetailsListLoading: false,
  BitbucketActiveUserDetailsCount:[],
  BitbucketActiveUserDetailsCountLoading: false,
  JenkinsActiveUserDetailsList:[],
  JenkinsActiveUserDetailsListLoading: false,
  JenkinsActiveUserDetailsCount:[],
  JenkinsActiveUserDetailsCountLoading: false,
  JiraActiveUserDetailsList:[],
  JiraActiveUserDetailsListLoading: false,
  JiraActiveUserDetailsCount:[],
  JiraActiveUserDetailsCountLoading: false,
  ConfluenceActiveUserDetailsList:[],
  ConfluenceActiveUserDetailsListLoading: false,
  ConfluenceActiveUserDetailsCount:[],
  ConfluenceActiveUserDetailsCountLoading: false,
  // InActive list
  JiraInActiveUserDetailsList:[],
  JiraInActiveUserDetailsListLoading: false,
  JiraInActiveUserDetailsCount:[],
  JiraInActiveUserDetailsCountLoading: false,
  ConfluenceInActiveUserDetailsList:[],
  ConfluenceInActiveUserDetailsListLoading: false,
  ConfluenceInActiveUserDetailsCount:[],
  ConfluenceInActiveUserDetailsCountLoading: false,
  BitbucketInActiveUserDetailsList:[],
  BitbucketInActiveUserDetailsListLoading: false,
  BitbucketInActiveUserDetailsCount:[],
  BitbucketInActiveUserDetailsCountLoading: false,
  JenkinsInActiveUserDetailsList:[],
  JenkinsInActiveUserDetailsListLoading: false,
  JenkinsInActiveUserDetailsCount:[],
  JenkinsInActiveUserDetailsCountLoading: false,
  ActiveuserdonutDetails:[],
  ActiveuserdonutDetailsLoading: false,
  getAnsibleData:[],
  getAnsibleLoading:false,

  //summary
  getCLUData:[],
  getCLULoader:false,

  //License insights by Discovery Type
  insightsbyDisTypeData:[],
  insightsbyDisTypeLoader:false,

  apiError : false,
};

export const LicenseSlice = createSlice({
  name: "LicenseSlice",
  initialState,

  reducers: {
    setApiError: (state, action) => {
      state.apiError = false;
     },
  },
  extraReducers: (builder) => {
    builder

      .addCase(LoginTrendApi.pending, (state, action) => {
        state.LoginTrendloading = true;
        state.apiError = false;
      })
      .addCase(LoginTrendApi.fulfilled, (state, action) => {
        state.LoginTrendData = action.payload;
        state.LoginTrendloading = false;
        state.apiError = false;
      })
      .addCase(LoginTrendApi.rejected, (state, action) => {
        state.LoginTrendloading = false;
        state.LoginTrendData = [];
        state.apiError = true;
      })

      .addCase(ActiveUsersLast.pending, (state, action) => {
        state.ActiveUsersLastLoading = true;
        state.apiError = false;
      })
      .addCase(ActiveUsersLast.fulfilled, (state, action) => {
        state.ActiveUsersLastData = action.payload;
        state.ActiveUsersLastLoading = false;
        state.apiError = false;
      })
      .addCase(ActiveUsersLast.rejected, (state, action) => {
        state.ActiveUsersLastLoading = false;
        state.ActiveUsersLastData = [];
        state.apiError = true;
      })

      .addCase(CurrentDayLoggedUsersPerToolsApi.pending, (state, action) => {
        state.CurrentDayToolsLoggedUsersLoading = true;
        state.apiError = false;
      })
      .addCase(CurrentDayLoggedUsersPerToolsApi.fulfilled, (state, action) => {
        state.CurrentDayToolsLoggedUsers = action.payload;
        state.CurrentDayToolsLoggedUsersLoading = false;
        state.apiError = false;
      })
      .addCase(CurrentDayLoggedUsersPerToolsApi.rejected, (state, action) => {
        state.CurrentDayToolsLoggedUsersLoading = false;
        state.apiError = true;
      })

      // Bitbucket users details
      .addCase(BitbucketUserDetailsListAPI.pending, (state, action) => {
        state.BitbucketUserDetailsListLoading = true;
        state.apiError = false;
      })
      .addCase(BitbucketUserDetailsListAPI.fulfilled, (state, action) => {
        state.BitbucketUserDetailsList = action.payload;
        state.BitbucketUserDetailsListLoading = false;
        state.apiError = false;
      })
      .addCase(BitbucketUserDetailsListAPI.rejected, (state, action) => {
        state.BitbucketUserDetailsListLoading = false;
        state.BitbucketUserDetailsList = [];
        state.apiError = true;
      })

      .addCase(BitbucketUserDetailsCountAPI.pending, (state, action) => {
        state.BitbucketUserDetailsCountLoading = true;
        state.apiError = false;
      })
      .addCase(BitbucketUserDetailsCountAPI.fulfilled, (state, action) => {
        state.BitbucketUserDetailsCount = action.payload;
        state.BitbucketUserDetailsCountLoading = false;
        state.apiError = false;
      })
      .addCase(BitbucketUserDetailsCountAPI.rejected, (state, action) => {
        state.BitbucketUserDetailsCountLoading = false;
        state.apiError = true;
      })
      // Jenkins users details
      .addCase(JenkinsUserDetailsListAPI.pending, (state, action) => {
        state.JenkinsUserDetailsListLoading = true;
        state.apiError = false;
      })
      .addCase(JenkinsUserDetailsListAPI.fulfilled, (state, action) => {
        state.JenkinsUserDetailsList = action.payload;
        state.JenkinsUserDetailsListLoading = false;
        state.apiError = false;
      })
      .addCase(JenkinsUserDetailsListAPI.rejected, (state, action) => {
        state.JenkinsUserDetailsListLoading = false;
        state.JenkinsUserDetailsList = [];
        state.apiError = true;
      })

      .addCase(JenkinsUserDetailsCountAPI.pending, (state, action) => {
        state.JenkinsUserDetailsCountLoading = true;
        state.apiError = false;
      })
      .addCase(JenkinsUserDetailsCountAPI.fulfilled, (state, action) => {
        state.JenkinsUserDetailsCount = action.payload;
        state.JenkinsUserDetailsCountLoading = false;
        state.apiError = false;
      })
      .addCase(JenkinsUserDetailsCountAPI.rejected, (state, action) => {
        state.JenkinsUserDetailsCountLoading = false;
        state.apiError = true;
      })


      // Jira user details
      .addCase(JiraUserDetailsListAPI.pending, (state, action) => {
        state.JiraUserDetailsListLoading = true;
        state.apiError = false;
      })
      .addCase(JiraUserDetailsListAPI.fulfilled, (state, action) => {
        state.JiraUserDetailsList = action.payload;
        state.JiraUserDetailsListLoading = false;
        state.apiError = false;
      })
      .addCase(JiraUserDetailsListAPI.rejected, (state, action) => {
        state.JiraUserDetailsListLoading = false;
        state.JiraUserDetailsList = [];
        state.apiError = true;
      })

      .addCase(JiraUserDetailsCountAPI.pending, (state, action) => {
        state.JiraUserDetailsCountLoading = true;
        state.apiError = false;
      })
      .addCase(JiraUserDetailsCountAPI.fulfilled, (state, action) => {
        state.JiraUserDetailsCount = action.payload;
        state.JiraUserDetailsCountLoading = false;
        state.apiError = false;
      })
      .addCase(JiraUserDetailsCountAPI.rejected, (state, action) => {
        state.JiraUserDetailsCountLoading = false;
        state.apiError = true;
      })
      // Confluence user details
      .addCase(ConfluenceUserDetailsListAPI.pending, (state, action) => {
        state.ConfluenceUserDetailsListLoading = true;
        state.apiError = false;
      })
      .addCase(ConfluenceUserDetailsListAPI.fulfilled, (state, action) => {
        state.ConfluenceUserDetailsList = action.payload;
        state.ConfluenceUserDetailsListLoading = false;
        state.apiError = false;
      })
      .addCase(ConfluenceUserDetailsListAPI.rejected, (state, action) => {
        state.ConfluenceUserDetailsListLoading = false;
        state.ConfluenceUserDetailsList = [];
        state.apiError = true;
      })

      .addCase(ConfluenceUserDetailsCountAPI.pending, (state, action) => {
        state.ConfluenceUserDetailsCountLoading = true;
        state.apiError = false;
      })
      .addCase(ConfluenceUserDetailsCountAPI.fulfilled, (state, action) => {
        state.ConfluenceUserDetailsCount = action.payload;
        state.ConfluenceUserDetailsCountLoading = false;
        state.apiError = false;
      })
      .addCase(ConfluenceUserDetailsCountAPI.rejected, (state, action) => {
        state.ConfluenceUserDetailsCountLoading = false;
        state.apiError = true;
      })

      // Bitbucket Active users details
      .addCase(BitbucketActiveUserDetailsListAPI.pending, (state, action) => {
        state.BitbucketActiveUserDetailsListLoading = true;
        state.apiError = false;
      })
      .addCase(BitbucketActiveUserDetailsListAPI.fulfilled, (state, action) => {
        state.BitbucketActiveUserDetailsList = action.payload;
        state.BitbucketActiveUserDetailsListLoading = false;
        state.apiError = false;
      })
      .addCase(BitbucketActiveUserDetailsListAPI.rejected, (state, action) => {
        state.BitbucketActiveUserDetailsListLoading = false;
        state.BitbucketActiveUserDetailsList = [];
        state.apiError = true;
      })

      .addCase(BitbucketActiveUserDetailsCountAPI.pending, (state, action) => {
        state.BitbucketActiveUserDetailsCountLoading = true;
        state.apiError = false;
      })
      .addCase(BitbucketActiveUserDetailsCountAPI.fulfilled, (state, action) => {
        state.BitbucketActiveUserDetailsCount = action.payload;
        state.BitbucketActiveUserDetailsCountLoading = false;
        state.apiError = false;
      })
      .addCase(BitbucketActiveUserDetailsCountAPI.rejected, (state, action) => {
        state.BitbucketActiveUserDetailsCountLoading = false;
        state.apiError = true;
      })
      // Jenkins Active users details
      .addCase(JenkinsActiveUserDetailsListAPI.pending, (state, action) => {
        state.JenkinsActiveUserDetailsListLoading = true;
        state.apiError = false;
      })
      .addCase(JenkinsActiveUserDetailsListAPI.fulfilled, (state, action) => {
        state.JenkinsActiveUserDetailsList = action.payload;
        state.JenkinsActiveUserDetailsListLoading = false;
        state.apiError = false;
      })
      .addCase(JenkinsActiveUserDetailsListAPI.rejected, (state, action) => {
        state.JenkinsActiveUserDetailsListLoading = false;
        state.JenkinsActiveUserDetailsList = [];
        state.apiError = true;
      })

      .addCase(JenkinsActiveUserDetailsCountAPI.pending, (state, action) => {
        state.JenkinsActiveUserDetailsCountLoading = true;
        state.apiError = false;
      })
      .addCase(JenkinsActiveUserDetailsCountAPI.fulfilled, (state, action) => {
        state.JenkinsActiveUserDetailsCount = action.payload;
        state.JenkinsActiveUserDetailsCountLoading = false;
        state.apiError = false;
      })
      .addCase(JenkinsActiveUserDetailsCountAPI.rejected, (state, action) => {
        state.JenkinsActiveUserDetailsCountLoading = false;
        state.apiError = true;
      })


      // Jira Active user details
      .addCase(JiraActiveUserDetailsListAPI.pending, (state, action) => {
        state.JiraActiveUserDetailsListLoading = true;
        state.apiError = false;
      })
      .addCase(JiraActiveUserDetailsListAPI.fulfilled, (state, action) => {
        state.JiraActiveUserDetailsList = action.payload;
        state.JiraActiveUserDetailsListLoading = false;
        state.apiError = false;
      })
      .addCase(JiraActiveUserDetailsListAPI.rejected, (state, action) => {
        state.JiraActiveUserDetailsListLoading = false;
        state.JiraActiveUserDetailsList = [];
        state.apiError = true;
      })

      .addCase(JiraActiveUserDetailsCountAPI.pending, (state, action) => {
        state.JiraActiveUserDetailsCountLoading = true;
        state.apiError = false;
      })
      .addCase(JiraActiveUserDetailsCountAPI.fulfilled, (state, action) => {
        state.JiraActiveUserDetailsCount = action.payload;
        state.JiraActiveUserDetailsCountLoading = false;
        state.apiError = false;
      })
      .addCase(JiraActiveUserDetailsCountAPI.rejected, (state, action) => {
        state.JiraActiveUserDetailsCountLoading = false;
        state.apiError = true;
      })
      // Confluence Active user details
      .addCase(ConfluenceActiveUserDetailsListAPI.pending, (state, action) => {
        state.ConfluenceActiveUserDetailsListLoading = true;
        state.apiError = false;
      })
      .addCase(ConfluenceActiveUserDetailsListAPI.fulfilled, (state, action) => {
        state.ConfluenceActiveUserDetailsList = action.payload;
        state.ConfluenceActiveUserDetailsListLoading = false;
        state.apiError = false;
      })
      .addCase(ConfluenceActiveUserDetailsListAPI.rejected, (state, action) => {
        state.ConfluenceActiveUserDetailsListLoading = false;
        state.ConfluenceActiveUserDetailsList = [];
        state.apiError = true;
      })

      .addCase(ConfluenceActiveUserDetailsCountAPI.pending, (state, action) => {
        state.ConfluenceActiveUserDetailsCountLoading = true;
        state.apiError = false;
      })
      .addCase(ConfluenceActiveUserDetailsCountAPI.fulfilled, (state, action) => {
        state.ConfluenceActiveUserDetailsCount = action.payload;
        state.ConfluenceActiveUserDetailsCountLoading = false;
        state.apiError = false;
      })
      .addCase(ConfluenceActiveUserDetailsCountAPI.rejected, (state, action) => {
        state.ConfluenceActiveUserDetailsCountLoading = false;
        state.apiError = true;
      })

         // Jira InActive user details
         .addCase(JiraInActiveUserDetailsListAPI.pending, (state, action) => {
          state.JiraInActiveUserDetailsListLoading = true;
          state.apiError = false;
        })
        .addCase(JiraInActiveUserDetailsListAPI.fulfilled, (state, action) => {
          state.JiraInActiveUserDetailsList = action.payload;
          state.JiraInActiveUserDetailsListLoading = false;
          state.apiError = false;
        })
        .addCase(JiraInActiveUserDetailsListAPI.rejected, (state, action) => {
          state.JiraInActiveUserDetailsListLoading = false;
          state.JiraInActiveUserDetailsList = [];
          state.apiError = true;
        })
  
        .addCase(JiraInActiveUserDetailsCountAPI.pending, (state, action) => {
          state.JiraInActiveUserDetailsCountLoading = true;
          state.apiError = false;
        })
        .addCase(JiraInActiveUserDetailsCountAPI.fulfilled, (state, action) => {
          state.JiraInActiveUserDetailsCount = action.payload;
          state.JiraInActiveUserDetailsCountLoading = false;
          state.apiError = false;
        })
        .addCase(JiraInActiveUserDetailsCountAPI.rejected, (state, action) => {
          state.JiraInActiveUserDetailsCountLoading = false;
          state.apiError = true;
        })

          // Confluence InActive user details
      .addCase(ConfluenceInActiveUserDetailsListAPI.pending, (state, action) => {
        state.ConfluenceInActiveUserDetailsListLoading = true;
        state.apiError = false;
      })
      .addCase(ConfluenceInActiveUserDetailsListAPI.fulfilled, (state, action) => {
        state.ConfluenceInActiveUserDetailsList = action.payload;
        state.ConfluenceInActiveUserDetailsListLoading = false;
        state.apiError = false;
      })
      .addCase(ConfluenceInActiveUserDetailsListAPI.rejected, (state, action) => {
        state.ConfluenceInActiveUserDetailsListLoading = false;
        state.ConfluenceInActiveUserDetailsList = [];
        state.apiError = true;
      })

      .addCase(ConfluenceInActiveUserDetailsCountAPI.pending, (state, action) => {
        state.ConfluenceInActiveUserDetailsCountLoading = true;
        state.apiError = false;
      })
      .addCase(ConfluenceInActiveUserDetailsCountAPI.fulfilled, (state, action) => {
        state.ConfluenceInActiveUserDetailsCount = action.payload;
        state.ConfluenceInActiveUserDetailsCountLoading = false;
        state.apiError = false;
      })
      .addCase(ConfluenceInActiveUserDetailsCountAPI.rejected, (state, action) => {
        state.ConfluenceInActiveUserDetailsCountLoading = false;
        state.apiError = true;
      })

           // Bitbucket InActive users details
           .addCase(BitbucketInActiveUserDetailsListAPI.pending, (state, action) => {
            state.BitbucketInActiveUserDetailsListLoading = true;
            state.apiError = false;
          })
          .addCase(BitbucketInActiveUserDetailsListAPI.fulfilled, (state, action) => {
            state.BitbucketInActiveUserDetailsList = action.payload;
            state.BitbucketInActiveUserDetailsListLoading = false;
            state.apiError = false;
          })
          .addCase(BitbucketInActiveUserDetailsListAPI.rejected, (state, action) => {
            state.BitbucketInActiveUserDetailsListLoading = false;
            state.BitbucketInActiveUserDetailsList = [];
            state.apiError = true;
          })
    
          .addCase(BitbucketInActiveUserDetailsCountAPI.pending, (state, action) => {
            state.BitbucketInActiveUserDetailsCountLoading = true;
            state.apiError = false;
          })
          .addCase(BitbucketInActiveUserDetailsCountAPI.fulfilled, (state, action) => {
            state.BitbucketInActiveUserDetailsCount = action.payload;
            state.BitbucketInActiveUserDetailsCountLoading = false;
            state.apiError = false;
          })
          .addCase(BitbucketInActiveUserDetailsCountAPI.rejected, (state, action) => {
            state.BitbucketInActiveUserDetailsCountLoading = false;
            state.apiError = true;
          })
           // Jenkins InActive users details
           .addCase(JenkinsInActiveUserDetailsListAPI.pending, (state, action) => {
            state.JenkinsInActiveUserDetailsListLoading = true;
            state.apiError = false;
          })
          .addCase(JenkinsInActiveUserDetailsListAPI.fulfilled, (state, action) => {
            state.JenkinsInActiveUserDetailsList = action.payload;
            state.JenkinsInActiveUserDetailsListLoading = false;
            state.apiError = false;
          })
          .addCase(JenkinsInActiveUserDetailsListAPI.rejected, (state, action) => {
            state.JenkinsInActiveUserDetailsListLoading = false;
            state.JenkinsInActiveUserDetailsList = [];
            state.apiError = true;
          })
    
          .addCase(JenkinsInActiveUserDetailsCountAPI.pending, (state, action) => {
            state.JenkinsInActiveUserDetailsCountLoading = true;
            state.apiError = false;
          })
          .addCase(JenkinsInActiveUserDetailsCountAPI.fulfilled, (state, action) => {
            state.JenkinsInActiveUserDetailsCount = action.payload;
            state.JenkinsInActiveUserDetailsCountLoading = false;
            state.apiError = false;
          })
          .addCase(JenkinsInActiveUserDetailsCountAPI.rejected, (state, action) => {
            state.JenkinsInActiveUserDetailsCountLoading = false;
            state.apiError = true;
          })
          .addCase(Activeuserdonut.pending, (state, action) => {
            state.ActiveuserdonutDetailsLoading = true;
            state.apiError = false;
          })
          .addCase(Activeuserdonut.fulfilled, (state, action) => {
            state.ActiveuserdonutDetails = action.payload;
            state.ActiveuserdonutDetailsLoading = false;
            state.apiError = false;
          })
          .addCase(Activeuserdonut.rejected, (state, action) => {
            state.ActiveuserdonutDetailsLoading = false;
            state.apiError = true;
          })

          //summary
          .addCase(getCurrentLicenseUtilization.pending, (state, action) => {
            state.getCLULoader = true;
            state.apiError = false;
          })
          .addCase(getCurrentLicenseUtilization.fulfilled, (state, action) => {
            state.getCLUData = action.payload;
            state.getCLULoader = false;
            state.apiError = false;
          })
          .addCase(getCurrentLicenseUtilization.rejected, (state, action) => {
            state.getCLULoader = false;
            state.apiError = true;
          })

          //License insights by Discovery Type
          .addCase(insightsbyDisTypeAPI.pending, (state, action) => {
            state.insightsbyDisTypeLoader = true;
            state.apiError = false;
          })
          .addCase(insightsbyDisTypeAPI.fulfilled, (state, action) => {
            state.insightsbyDisTypeData = action.payload;
            state.insightsbyDisTypeLoader = false;
            state.apiError = false;
          })
          .addCase(insightsbyDisTypeAPI.rejected, (state, action) => {
            state.insightsbyDisTypeLoader = false;
            state.apiError = true;
          })

          //Ansible Automation
          .addCase(getAnsibleAPI.pending, (state, action) => {
            state.getAnsibleLoading = true;
            state.apiError = false;
          })
          .addCase(getAnsibleAPI.fulfilled, (state, action) => {
            state.getAnsibleData = action.payload;
            state.getAnsibleLoading = false;
            state.apiError = false;
          })
          .addCase(getAnsibleAPI.rejected, (state, action) => {
            state.getAnsibleLoading = false;
            state.apiError = true;
          })

  },
});
export const {setApiError} = LicenseSlice.actions;
export default LicenseSlice.reducer;